<div class="popup-container">
    <div class="centered-div" *ngIf="loading">
        <mat-spinner [color]="'primary'" [diameter]="50"></mat-spinner>

    </div>
    <ng-container>
        <h2 class="title">Caution!</h2>
        <p class="message">
            Do you want to start over again, all the progress done will be lost. Do you wish to continue?
        </p>

        <div class="button-container">

            <button mat-button class="cancel-button" (click)="cancel()">Cancel</button>
            <button mat-button class="force-button" (click)="confirmRedirect()">Proceed</button>
        </div>
    </ng-container>
</div>